export default __webpack_public_path__ + "static/downtown_vinewood_weed_farm-1e4173906866fcb0b555923a3826ad30.png";